// Local type cast — this package's tsconfig doesn't include globals-shared.d.ts.
type WebViewWindow = {
  isWebViewV2?: boolean;
  ReactNativeWebView?: unknown;
};

/**
 * True when rendered inside our native React Native WebView host
 * (`ReactNativeWebView` bridge or the `isWebViewV2` global the native side injects).
 */
export function isWebView(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  const win = window as unknown as WebViewWindow;

  return win.isWebViewV2 === true || Boolean(win.ReactNativeWebView);
}
